<template>
  <div>
    <div class="joinCurriculum">
      <div class="basic-information-title">参与课程</div>
      <div class="redactImg"></div>
    </div>
          <div class="product-list" v-if="list.length>0">
        <div v-for="(item,index) in list" v-bind:key="index">
          <!-- <div class="flex product-list-header"  v-if="item.uploadedShow==1"> -->
          <div class="flex product-list-header"  v-if="false">  
            <div class="flex center"  >
              <img class="camera" :src="require('@/assets/img/camera.png')" alt>
            </div>
            <div>
                <div  class="plan-noSuccess"   @click="lookProduction(item.courseMemberId,item.userId)" >查看作品</div>
            </div>
         </div>

          <div class="product-list-content">
            <div
              class="basic-information-flex"
            >
              <ul class="basic-information-lists">
                <li>
                  <div class="basic-information-lists-item">课程日期</div>
                  <div class="basic-information-lists-text">{{(item.rangeTime||'')}}</div>
                </li>
                <li>
                  <div class="basic-information-lists-item">课程类型</div>
                  <div class="basic-information-lists-text">{{item.type||''}}</div>
                </li>
                <li>
                  <div class="basic-information-lists-item">课程名称</div>
                  <div class="basic-information-lists-text">{{item.name||''}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>


<script>
export default {
  name: "",
  data() {
    return {
       list: [],
    };
  },
  methods: {
   /**
     *
     *  参加客户课程列表
     *
     */
    joinCurriculumList(custId){
      this.$api.joinCurriculumList({salesId:this.$wxuserUtil.getUserId(),custId:custId}).then(Response=>{
          if(Response.success==true){
            let $data   =  Response.data;
              if($data.length>0){
              for(let i=0;i<$data.length;i++){
                   $data[i]['rangeTime']=(function(D){
                       var D_ =  D.replace(/\//g,",").replace(/-/g,"/");
                       var S_ =  D_.replace(/,/,'-')
                       return   S_;
                   }($data[i]['rangeTime']))
              }
               this.list=$data;
              }
          }else{
              this.$title(Response.msg);
          }
      })
    },
    /**
     *
     *  查看作品
     *
     */
   lookProduction(ID, index) {
      let lookProduction=false;
      if(index){
        lookProduction=true;
      }else{
        lookProduction=false;
      }
        this.$router.push({
          path: "/lookProduction",
          query: { lookProduction: lookProduction, ID,G:2,menuId:this.$parent.$parent.IdCode }
        });
    },
  },
  mounted() {},
  created() {}
};
</script>



<style lang="less" scoped>
.plan-noSuccess{
  font-weight: bold;
  color:red;
  text-decoration: underline;
}
.joinCurriculum {
  // width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  -ms-flex-item-align: center;
  align-items: center;
  height: 1rem;
  padding: 0.3rem 0.5rem 0rem 0.5rem;
  border-top: 0.1rem solid rgb(244, 244, 244);
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
  .basic-information-title {
    position: relative;
    color: #2a2a2a;
    font-size: 0.4rem;
    font-weight: 600;
  }
  .basic-information-title::after {
    content: "";
    width: 0.1rem;
    height: 0.35rem;
    position: absolute;
    left: -0.2rem;
    top: 0.12rem;
    background-color: #e10913;
  }
}

.product-list {
  margin: 0.3rem 0.5rem 0.3rem 0.5rem;
  // background: #F2F2F2;
  min-height: 1rem;
  .basic-information-flex {
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    -ms-transition: all 0.5s;
    .basic-information-lists {
      li {
        display: flex;
        //    justify-content: space-between;
        -ms-flex-item-align: center;
        align-items: center;
        height: 0.8rem;
        line-height: 0.8rem;
      }
      .basic-information-lists-item {
        width: 2.5rem;
        color: #7e7e7e;
        font-size: 0.35rem;
      }
      .basic-information-lists-text {
        font-size: 0.35rem;
        color: #4d4d4d;
      }
    }
  }
  .product-list-content {
    background: #f2f2f2;
    margin-bottom: .3rem;
  }
  .packUp {
    padding: 0rem 0.3rem;
    background: #f2f2f2;
    margin-top: 0.05rem;
    margin-bottom: 0.3rem;
    height: 1rem;
    line-height: 1rem;
  }
  .arrow {
    width: 0.4rem;
    height: 0.4rem;
  }
  .product-list-header {
    height: 1rem;
    -ms-flex-item-align: center;
    align-items: center;
    padding: 0rem 0.3rem;
    flex-direction: row;
    justify-content: space-between;
    background: #f2f2f2;
    .product-name {
      color: #2a2a2a;
      font-size: 0.4rem;
      padding-left: 0.3rem;
    }
  }
  .camera,
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/joinCurriculum.vue